/**
 * Copyright (c) Omnissa, LLC. All rights reserved.
 * This product is protected by copyright and intellectual property laws in the
 * United States and other countries as well as by international treaties.
 * -- Omnissa Restricted
 *
 * @format
 */

import { NgModule } from "@angular/core";
import { NormalizationService } from "./normalization-service";
import { WmksBaseService } from "./wmks-base-service";
import { CoordinateConverter } from "./coordinate-converter";

@NgModule({
   declarations: [],
   providers: [NormalizationService, WmksBaseService, CoordinateConverter]
})
export class UtilsModule {}
